import * as $ from 'jquery';
import 'bootstrap';
import Chart from 'chart.js/auto';

export default (function () {
  let $chartWrapper = $('#reviewsChart');

  if (0 < $chartWrapper.length) {
    const data = [chartData.pending, chartData.review, chartData.passed, chartData.failed];

    new Chart($($chartWrapper), {
      type: 'bar',
      data: {
        labels: ['Pending Review', 'On Review', 'Pass', 'Fail'],
        datasets: [{
            label: '',
          data,
          backgroundColor: [
            '#a0afbe',
            '#ff600f',
            '#00cd91',
            '#ff5454',
          ],
          borderColor: [
            '#a0afbe',
            '#ff600f',
            '#00cd91',
            '#ff5454',
          ],
          borderWidth: 2,
        }],
      },
      options: {
        responsive: true,
        animation: {
          animateScale: true
        },
        scales: {
          y: {
            // max value of data, plus 10%, rounded to the closest integer
            max: Math.ceil(Math.max(...data) * 1.1),
            ticks: {
              beginAtZero: true,
              callback: function (value) { if (Number.isInteger(value)) { return value; } },
              stepSize: 1
            }
          }
        },
        plugins: {
          legend: false,
          tooltip:{
            callbacks:{
              title: ()=>{}
            }
          }
        }
      },
    });
  }

}())
